export default "__VITE_ASSET__BQg$UYpf__"